import React, { useContext } from 'react'
import css from "./completeModal.module.scss"
import { AuthContext } from "../../../context/auth";

export const CompleteModal = () => {
  const { setCompleteModal } = useContext(AuthContext)
  return (
    <div className={css.modalWrapper}>
      <div className={css.modalContent}>
        <div style={{ position: 'relative', justifyContent: 'center', display: 'flex', width: '100%' }}>
          <span className={css.closeIcon} onClick={() => setCompleteModal(false)}>
          <i className='fal fa-times'></i>
          </span>
          <span className={css.icon}>
            <i class="fal fa-check"></i>
          </span>
        </div>
        <h2>Thank You for Registering with IDENTiFYN® </h2>
        <button className={`btn ${css.btn} ${css.ctaBtn}`} onClick={() => {
          setCompleteModal(false)
        }}>Complete Registration</button>
      </div>
    </div>
  )
}